import SEO from './SEO';

export const HomeSEO = () => (
  <SEO
    title="RatedBite - Discover the Best Dishes Based on Food Quality"
    description="Rate and discover amazing dishes based on food quality only. Find the best pizza, burgers, sushi, and more. Join our community of food lovers who focus on taste, not service."
    keywords="food rating, dish reviews, food quality, restaurant dishes, best food, food discovery, dish recommendations"
  />
);

export const LeaderboardSEO = () => (
  <SEO
    title="Dish Leaderboard - Top Rated Dishes | RatedBite"
    description="Discover the most popular and highest-rated dishes on RatedBite. See trending dishes, top votes, and community favorites."
    keywords="top dishes, popular dishes, trending food, dish leaderboard, best rated dishes, community favorites"
  />
);

export const ProfileSEO = () => (
  <SEO
    title="My Profile - Favorites & Recommendations | RatedBite"
    description="View your favorite dishes, personalized recommendations, and voting history on RatedBite."
    keywords="user profile, favorite dishes, personalized recommendations, food preferences"
  />
);

export const DishDetailSEO = ({ dish }) => (
  <SEO
    title={`${dish?.name || 'Dish'} - Food Quality Rating | RatedBite`}
    description={`Rate and review ${dish?.name || 'this dish'} based on food quality only. ${dish?.restaurantName ? `From ${dish.restaurantName}.` : ''} See community ratings and photos.`}
    keywords={`${dish?.name}, ${dish?.dishType || ''}, ${dish?.cuisine || ''}, food rating, dish review, food quality`}
    image={dish?.imageUrl}
    type="article"
    dish={dish}
  />
);

export const SupperClubSEO = () => (
  <SEO
    title="Supper Club - Exclusive Dining Events | RatedBite"
    description="Join exclusive dining experiences at top-rated restaurants. Meet chefs, taste exceptional dishes, and connect with fellow food lovers at RatedBite Supper Club events."
    keywords="supper club, dining events, chef experiences, exclusive dining, food events, restaurant events"
  />
);

export const EventDetailSEO = ({ event }) => (
  <SEO
    title={`${event?.title || 'Event'} - RatedBite Supper Club`}
    description={`${event?.description || 'Join us for an exclusive dining experience'}. ${event?.chef ? `Featuring ${event.chef}.` : ''} ${event?.date ? `On ${new Date(event.date).toLocaleDateString()}.` : ''}`}
    keywords={`${event?.title}, ${event?.chef || ''}, supper club, dining event, ${event?.restaurant || ''}`}
    image={event?.imageUrl}
    type="event"
  />
);
